var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "ml-3" }, [
          _c("strong", [_vm._v("\n\t\t\t\t\tПідрозділ\n\t\t\t\t")]),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n\t\t\t\t" + _vm._s(this.user.department) + "\n\t\t\t"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "ml-3" }, [
          _c("strong", [_vm._v("\n\t\t\t\t\tПосада\n\t\t\t\t")]),
          _vm._v(" "),
          _c("br"),
          _vm._v("\n\t\t\t\t" + _vm._s(this.user.dolznost) + "\n\t\t\t"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "ml-3" }, [
          _c("strong", [_vm._v("\n\t\t\t\t\tEmail\n\t\t\t\t")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("a", { staticClass: "imc_a", attrs: { href: _vm.mail_href } }, [
            _vm._v(_vm._s(this.user.email)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "ml-3" }, [
          _c("strong", [_vm._v("\n\t\t\t\t\tМоб.телефон\n\t\t\t\t")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("a", { staticClass: "imc_a", attrs: { href: _vm.tel_href1 } }, [
            _vm._v(_vm._s(this.user.mobile)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "ml-3" }, [
          _c("strong", [_vm._v("\n\t\t\t\t\tМоб телефон 2\n\t\t\t\t")]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("a", { staticClass: "imc_a", attrs: { href: _vm.tel_href2 } }, [
            _vm._v(_vm._s(this.user.home)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("b-overlay", { attrs: { show: _vm.show, rounded: "sm" } }, [
        _c("div", { staticClass: "d-flex flex-row align-items-center p-2" }, [
          _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
            _c("i", {
              staticClass:
                "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
            }),
            _vm._v(" "),
            _c("i", {
              staticClass:
                "fas fa-pennant icon-stack-1x opacity-100 color-primary-500",
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-3" }, [
            _c("strong", [_vm._v("\n\t\t\t\t\t\tВідпустка\n\t\t\t\t\t")]),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("div", [_vm._v(_vm._s(_vm.vacation))]),
          ]),
        ]),
        _vm._v(" "),
        _vm.obj_to_null(this.cur_vacation)
          ? _c(
              "div",
              { staticClass: "d-flex flex-row align-items-center p-2" },
              [
                _c(
                  "div",
                  { staticClass: "icon-stack display-3 flex-shrink-0" },
                  [
                    _c("i", {
                      staticClass:
                        "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
                    }),
                    _vm._v(" "),
                    _c("i", {
                      staticClass:
                        "fas fa-pennant icon-stack-1x opacity-100 color-primary-500",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "ml-3" }, [
                  _c("strong", [
                    _vm._v(
                      "\n                        Поточна відпустка\n                    "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _c("div", [
                    _c("span", { staticClass: "badge badge-warning" }, [
                      _vm._v(
                        "Відпустка на період " +
                          _vm._s(this.cur_vacation.d_from) +
                          " - " +
                          _vm._s(this.cur_vacation.d_to)
                      ),
                    ]),
                  ]),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass:
          "fas fa-building icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fas fa-user icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fal fa-at icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fas fa-phone icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "icon-stack display-3 flex-shrink-0" }, [
      _c("i", {
        staticClass:
          "fal fa-circle icon-stack-3x opacity-100 color-primary-400",
      }),
      _vm._v(" "),
      _c("i", {
        staticClass: "fal fa-phone icon-stack-1x opacity-100 color-primary-500",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }